import * as React from "react"

const Badge = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={`inline-flex items-center rounded-lg px-3 py-1 text-xs font-bold border-2 border-primary/30 shadow-[2px_2px_0_rgba(59,130,246,0.2)] transition-all duration-150 hover:shadow-[3px_3px_0_rgba(59,130,246,0.25)] uppercase tracking-wide ${className}`}
      {...props}
    />
  )
})
Badge.displayName = "Badge"

export { Badge }
